// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "./assets/" + {"96":"vendors","804":"shared","853":"revealer","915":"trending-now"}[chunkId] + ".js";
};